import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { createDiscoveryCard } from '@vfde-brix/ws10/discovery-card';
import { HtmlId } from '../enums/elementId';

/**
 * Creates a WS10 Discovery Card component.
 */
export const mountDiscoveryCard = (id: HtmlId) =>
    createComponentById(createDiscoveryCard, id, NO_PATTERN_BUSINESS_LOGIC);
